<template>
  <section class="about">
    <div class="ackground-container"></div>
    <div class="head">
      <div class="container title-container">
        <h1>香港美格科技有限公司</h1>
      </div>

      <el-row class="container" :gutter="20">
        <el-col class="title-r" :span="24">
          <h3>公司简介 | Company Overview</h3>

          <p>
            <strong>
              香港美格科技有限公司（HONGKONG MEGA TECHNOLOGY
              LIMITED）是一家专注于跨境电商数字化与智能化解决方案 </strong
            >的高科技企业，致力于通过人工智能、大数据与供应链可视化技术，打造面向全球市场的<strong>智能出海基础设施</strong>。
          </p>
          <p>
            公司位于香港，在中国内地及北美均设有技术与服务中心，长期为制造企业、品牌商及跨境服务提供商提供系统化、可持续的<strong>全球数字贸易服务体系</strong>。
          </p>
          <p>
            我们相信，数字化是全球商业的新通用语言。美格科技致力于通过技术创新与生态协同，让中国制造与全球消费者实现真正的<strong>无缝连接</strong>。
          </p>
        </el-col>
        <el-col class="title-r" :span="24">
          <h3>核心品牌与平台 | Our Core Platform – XPORT</h3>
          <p>
            XPORT是香港美格科技有限公司自主建设与运营的智能跨境电商生态平台。
            平台以“<strong>AI驱动全球电子商务</strong>”为核心理念，致力于消除商家与消费者之间的边界，为全球在线买家和卖家提供<strong>无缝的本地化体验</strong>。
          </p>

          <p>
            我们构建了一个智能驱动的<strong>跨境出海生态系统</strong>，融合平台服务、供应链能力与本地化履约网络，帮助每一件优质商品跨越国界，精准触达全球消费者。
          </p>
          <p>
            作为<strong>美国、欧洲和亚洲品牌及零售商的合作伙伴</strong>，XPORT正在重新定义全球电子商务的标准——让“全球电商即本地电商体验”。
          </p>
        </el-col>

        <el-col class="title-r" :span="24">
          <h3>数字化服务体系 | Digital Service System</h3>
          <p>
            <strong> 智能海关申报系统（Intelligent Customs Declaration）</strong
            ><br />
            支持多国关务标准与自动申报接口，内置HS编码识别、税费计算、舱单管理与清关状态跟踪，实现“一键报关，全程可视”。
          </p>
          <p>
            <strong> 贸易合规管理平台（Trade Compliance Platform）</strong
            ><br />
            集成全球贸易法规与原产地数据库，支持敏感商品识别、出口管制校验与风险监测，确保企业跨境业务合法合规。
          </p>
          <p>
            <strong> 供应链控制台（Supply Chain Control Tower）</strong><br />
            汇聚订单、物流、库存、财务与风控数据，通过AI可视化分析实现供应链全局监控与智能决策，提升跨境履约与资金效率。
          </p>
          <p>
            <strong> AI营销与数据洞察（AI Marketing & Global Insights）</strong
            ><br />
            基于智能算法的市场热度分析、竞品监测与广告投放优化，帮助品牌实现全球精准增长与持续竞争力。
          </p>
        </el-col>

        <el-col class="title-r" :span="24">
          <h3>我们的使命 | Our Mission</h3>
          <p>
            让中国制造的每一件优质商品，跨越国界，
            以<strong>智能、合规、可视化的方式</strong>触达全球消费者。
          </p>

          <p>
            We empower global commerce through AI, compliance, and connectivity.
          </p>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="our-course">
      <h1 class="title">我们的环球之旅</h1>
      <course class="content"></course>
    </div> -->
    <div class="our-values">
      <h1 class="title">我们的价值观</h1>
      <div class="values-content">
        <el-row :gutter="20">
          <el-col class="item" :span="8">
            <div>
              <img src="@/assets/about/client.svg" alt="" />
              <h1 class="title">客户至上</h1>
              <p class="text">
                <strong>我们的零售合作伙伴的成功就是我们的成功：</strong>
                我们的零售客户及其客户是我们业务的核心。我们致力于客户的持续国际增长，并专注于使他们能够为国际客户提供一流的体验。
              </p>
            </div>
          </el-col>
          <el-col class="item" :span="8">
            <div>
              <img src="@/assets/about/innovative.svg" alt="" />
              <h1 class="title">创新</h1>
              <p class="text">
                <strong>重塑全球电子商务世界：</strong>
                我们将不断发展的先进技术与先进的 BI
                数据分析相结合，将国际电子商务提升到一个新的水平，以持续优化结果。
              </p>
            </div>
          </el-col>
          <el-col class="item" :span="8">
            <div>
              <img src="@/assets/about/team.svg" alt="" />
              <h1 class="title">以团队为中心</h1>
              <p class="text">
                <strong>我们的员工是我们成功的关键：</strong>
                Xport 汇集了来自世界各地的人才和全球 7
                个办事处的数十个国家的员工，将创造力、技能和辛勤工作带到了桌面上。
              </p>
            </div>
          </el-col>
          <el-col class="item" :span="8">
            <div>
              <img src="@/assets/about/sustainability.svg" alt="" />
              <h1 class="title">可持续性</h1>
              <p class="text">
                <strong>让世界变得更美好：</strong>
                我们对可持续发展的承诺从内部开始，并延伸到我们的合作伙伴品牌和供应商。我们正在努力将我们的货物转变为“无纸化”流式工作，并鼓励我们的合作伙伴品牌和零售商专注于减小包装尺寸并使用可回收和可持续的材料。
              </p>
            </div>
          </el-col>
          <el-col class="item" :span="8">
            <div>
              <img src="@/assets/about/community.svg" alt="" />
              <h1 class="title">社区</h1>
              <p class="text">
                <strong>回馈我们经营所在的社区：</strong>
                Xport
                包含各种非营利组织，这些组织雇用身体和精神残疾人士，并支持当地慈善机构帮助有需要的儿童和成人。
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="our-loc">
      <h1 class="title">我们的全球合作伙伴</h1>
    </div>
    <div class="map-box">
      <div class="item">
        <div class="map"></div>
        <div class="loc"></div>
      </div>
      <div class="item">
        <div class="map"></div>
        <div class="loc"></div>
      </div>
      <div class="item">
        <div class="map"></div>
        <div class="loc"></div>
      </div>
    </div>
  </section>
</template>

<script>
import Course from './component/course.vue'

export default {
  components: {
    Course
  },
  name: 'about',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="less">
.about {
  p,
  h1,
  div {
    font-family: 'Arimo';
  }
  position: relative;
  padding: 40vh 3% 100px;
  background-color: #fff;
  .ackground-container {
    position: absolute;
    width: 100vw;
    background: url(../../assets/about/gywm.png) 50% 50%;
    height: 40vh;
    background-size: cover;
    left: 0;
    top: 0;
  }

  .head {
    .title-container {
      padding-block-start: 0;
      -webkit-padding-after: 0px;
      padding-block-end: 0 !important;
      & > h1 {
        font-size: 40px;
        margin-top: 42px;
        color: #000;
      }
    }
    // & > h3 {
    //   font-size: 24px;
    //   text-align: center;
    //   margin-top: 12px;
    //   color: #000;
    // }

    .container {
      max-width: 1140px;
      margin: 0 auto !important;
      padding-block-start: 0;
      padding-block-end: 60px;
      flex-direction: row;
      .title-l {
        padding-left: 0 !important;
        font-size: 48px;
        font-weight: 600;
        color: #2a2c2f;
        font-family: 'Poppins', Sans-serif;
        line-height: 50px;
        white-space: break-spaces;
      }
      .title-r {
        // padding-left: 40px !important;
        padding-right: 0 !important;
        h3 {
          font-size: 24px;
          margin-bottom: 22px;
          margin-top: 44px;
          line-height: 1em;

          border-left: 4px solid #2f5ad9;
          padding-left: 12px;
        }
        p {
          font-size: 16px;
          font-weight: 400;
          line-height: 2em;
          text-indent: 2em;
          strong {
            color: #000;
          }
        }
      }
    }
  }
  .our-course {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-block-end: 150px;
    padding-block-start: 70px;
    gap: 50px;
    .title {
      font-size: 48px;
      font-family: 'Poppins', Sans-serif;
      text-align: center;
    }
    .content {
      flex: 1;
      width: 72% !important;
      margin: 0 auto;
    }
  }
  .our-values {
    .title {
      font-size: 48px;
      font-family: 'Poppins', Sans-serif;
      text-align: center;
    }
    .values-content {
      margin: 0 auto !important;
      width: 1140px;
      flex-wrap: wrap;
      .el-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
      .item {
        div {
          padding: 60px 10% !important;
          text-align: center;
          img {
            width: 100px;
            height: 100px;
          }
          .title {
            line-height: 17.6px;
            font-size: 26px;
            font-weight: 600;
            font-family: 'Poppins', Sans-serif;
            letter-spacing: -0.785px;
            margin-block-start: 8px;
            margin-block-end: 16px;
          }
          .text {
            font-size: 16px;
            color: #2a2b2f;
            line-height: 22.4px;
          }
        }
      }
      .item:nth-child(4) {
        div {
          padding: 60px 6% !important;
        }
      }
    }
  }
  .our-loc {
    .title {
      font-size: 48px;
      font-family: 'Poppins', Sans-serif;
      text-align: center;
      padding-block-start: 120px;
      padding-block-end: 60px;
    }
  }
  .map-box {
    height: 71vh;
    display: flex;
    .item {
      flex: 1;
      position: relative;
      .map,
      .loc {
        position: absolute;
        background-size: cover;
        width: 100%;
        height: 100%;
        transition: all 0.6s ease-in-out;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .loc {
        z-index: 10;
        opacity: 0;
      }
    }
    .item:hover {
      .map {
        opacity: 0;
      }
      .loc {
        opacity: 1;
      }
    }
    .item:nth-child(1) {
      .map,
      .loc {
        background-position: top right;
      }
      .map {
        background-image: url('../../assets/about/Group-32981.svg');
      }
      .loc {
        background-image: url('../../assets/about/Group-32984-3.svg');
      }
    }
    .item:nth-child(2) {
      .map,
      .loc {
        background-position: top center;
      }
      .map {
        background-image: url('../../assets/about/Group-32979.svg');
      }
      .loc {
        background-image: url('../../assets/about/Group-32982-1.svg');
      }
    }
    .item:nth-child(3) {
      .map,
      .loc {
        background-position: top left;
      }
      .map {
        background-image: url('../../assets/about/Group-32980.svg');
      }
      .loc {
        background-image: url('../../assets/about/Group-32983-1.svg');
      }
    }
  }
}
</style>
